import { HelpComponent } from './../../components/help/help';
import { ModalController } from 'ionic-angular';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

/*
  Generated class for the HelpProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class HelpProvider {

  constructor(private modalCtrl: ModalController) {
  }

  public openTOS(){
    let modal = this.modalCtrl.create(HelpComponent, {slug: 'terms-of-service', title: 'Terms of Service'});
    modal.present();
  }

  public openPrivacyPolicy(){
    let modal = this.modalCtrl.create(HelpComponent, {slug: 'privacy-policy', title: 'Privacy Policy'});
    modal.present();
  }

  public openAbout(){
    let modal = this.modalCtrl.create(HelpComponent, {slug: 'about-blocktistics'});
    modal.present();
  }

  public openSignals(){
    let modal = this.modalCtrl.create(HelpComponent, {slug: 'how-our-signals-work'});
    modal.present();
  }

  public openGrades(){
    let modal = this.modalCtrl.create(HelpComponent, {slug: 'grades'});
    modal.present();
  }

  public openRewards(){
    let modal = this.modalCtrl.create(HelpComponent, {slug: 'rewards-program'});
    modal.present();
  }

  public openCoinData(){
    let modal = this.modalCtrl.create(HelpComponent, {slug: 'coin-data'});
    modal.present();
  }

}



// WEBPACK FOOTER //
// ./src/providers/help/help.ts